const selectIncidentsCount = (state) => (state.polling.incidentsCount?.openIncidents + state.polling.incidentsCount?.challengedIncidents)
const selectError = (state) => state.polling.error

export { selectIncidentsCount, selectError }
